export const ROOT_DOCUMENTS_VIEW_SLUG = 'all-documents' as const

export const ALL_DOCUMENTS_AND_FIELDS_VIEW_SLUG =
  'all-documents-and-fields' as const

export const ARCHIVED_DOCUMENTS_VIEW_SLUG = 'archived-documents' as const

export const DEFAULT_NORMAL_FILTER_GROUP_INDEX = 1 as const

export const GENERAL_VIEW_SLUGS: string[] = [
  ROOT_DOCUMENTS_VIEW_SLUG,
  ALL_DOCUMENTS_AND_FIELDS_VIEW_SLUG,
] as const

export const GOOGLE_DRIVE_VIEW_SLUG = 'google-drive' as const
